import React from 'react';
import ButtonWithIcon from 'chameleon/ui-stack/ui/buttons/button-with-icon';
import InformationalPopover from 'chameleon/ui-stack/ui/popovers/informational-popover';
import './IconTrigger.scss';
import cn from 'classnames';
import styles from './styles.css';

const splitLabelAtWordCount = (
  label,
  isDisabledClassName,
  numberOfWords = 1,
) => {
  const words = label.split(' ');
  const breakPoint = Math.min(words.length, numberOfWords);
  const initialWords = words.slice(0, breakPoint).join(' ');
  const remainingWords = words.slice(breakPoint).join(' ');

  return (
    <span className={`download-text ${isDisabledClassName}`}>
      <span>{initialWords}</span>
      <span>{remainingWords.length > 0 ? ` ${remainingWords}` : ''}</span>
    </span>
  );
};

const btnDataTestIdSuffix = '_button';
const ICONS_OBJ = {
  generate_sheet: 'generate_sheet',
  download_sheet: 'download_sheet',
  upload_sheet: 'upload_sheet',
  live_session: 'live_session',
};

const BUTTON_DATA_TEST_ID = {
  generateAnswerSheets: `${ICONS_OBJ.generate_sheet}${btnDataTestIdSuffix}`,
  downloadAnswerSheets: `${ICONS_OBJ.download_sheet}${btnDataTestIdSuffix}`,
  uploadAnswerSheets: `${ICONS_OBJ.upload_sheet}${btnDataTestIdSuffix}`,
  manageLiveTestSession: `${ICONS_OBJ.live_session}${btnDataTestIdSuffix}`,
};

const ACTION_BUTTONS_SELECTORS = {
  GENERATE_ANSWER_SHEETS: BUTTON_DATA_TEST_ID.generateAnswerSheets,
  DOWNLOAD_ANSWER_SHEETS: BUTTON_DATA_TEST_ID.downloadAnswerSheets,
  UPLOAD_ANSWER_SHEETS: BUTTON_DATA_TEST_ID.uploadAnswerSheets,
  MANAGE_LIVE_SESSION: BUTTON_DATA_TEST_ID.manageLiveTestSession,
};

const IconTrigger = React.memo(
  ({
    iconName,
    label,
    onClick,
    children,
    isDisabled = false,
    toolTipContent,
    splitAfterWordCount,
    dataTestId,
  }) => {
    const isDisabledClassName = isDisabled ? 'disabled' : 'active';
    return (
      <div className="relative pl-4 flex">
        <ButtonWithIcon
          icon={iconName}
          iconAccessibility={{ 'aria-label': label }}
          aria-label={label}
          onClick={onClick}
          iconOrientation="center"
          className={`icon-trigger ${isDisabledClassName}`}
          iconClassName={isDisabledClassName}
          disabled={isDisabled}
          dataTestId={dataTestId}
          isNaked
        >
          {splitLabelAtWordCount(
            label,
            isDisabledClassName,
            splitAfterWordCount,
          )}
          {children}
        </ButtonWithIcon>
        {toolTipContent && (
          <div className={cn(styles['popover-tooltip'])}>
            <InformationalPopover
              size="medium"
              defaultOpen={false}
              accessibility={{
                'aria-label': `More info - ${label}`,
                role: 'tooltip',
              }}
            >
              {toolTipContent}
            </InformationalPopover>
          </div>
        )}
      </div>
    );
  },
);

export {
  splitLabelAtWordCount,
  ICONS_OBJ,
  ACTION_BUTTONS_SELECTORS,
  BUTTON_DATA_TEST_ID,
};
export default IconTrigger;
